import React from "react";
import { useNavigate } from "react-router-dom";
import { wineData } from "../Components/wineData"; 

const Gallery = () => {
  const navigate = useNavigate();
  const importAll = (r) => r.keys().map(r);
  const galleryImages = importAll(
    require.context("../assets/Gallery", false, /\.(jpg|jpeg|png)$/)
  );

  // match the wine name in alphabetical oreder from the folder brfore adding 
  // new wines to the gallery. This is important because the prices array is in alphabetical 
  // order of wine names. If you add a new wine, make sure to add it in the correct position in the prices array as well.

  const wineIds = [
    "beetroot-wine",       
    "black-grape-wine",    
    "chikku-wine",         
    "red-dragon-fruit-wine",   
    "ginger-wine",         
    "green-grape-wine",    
    "jamun-wine",          
    "raisins-wine",        
    "mango-wine",          
    "mohua-wine",          
    "pineapple-wine",      
    "pomegranate-wine",    
    "rose-wine",           
    "watermelon-wine",     
    "white-jamun-wine",    
  ];

  const prices = [
    "Rs 250", // Beetroot
    "Rs 450", // Black Grape
    "Rs 250", // Chikku
    "Rs 600", // Red Dragon Fruit
    "Rs 450", // Ginger
    "Rs 450", // Green Grape
    "Rs 500", // Jamun
    "Rs 350", // Kishmish 
    "Rs 250", // Mango
    "Mohua wine Launching shortly", // Mohua
    "Rs 350", // Pineapple
    "Drinking good wine with good food in good company is one of life's most civilized pleasures. ... Coming Soon", // Pomegranate
    "Rs 450", // Rose
    "Rs 250", // Watermelon
    "Rs 350", // White Jamun
  ];

  return (
    <section className="bg-[--neutral-light-gray] py-24 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto space-y-20">
        {/* HEADER */}
        <div className="text-center space-y-5">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-[--primary-wine] tracking-tight">
            Wine Moments Captured 🍷
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Explore timeless glimpses from our vineyards, cellars, and celebrations. Every photo celebrates our legacy and passion in winemaking.
          </p>
        </div>

        {/* GALLERY GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 place-items-center">
          {galleryImages.map((img, index) => {
            const currentWineId = wineIds[index];
            // Check if the wine ID exists in your wineData array
            const isWineAvailable = wineData.some(wine => wine.id === currentWineId);

            return (
              <div key={index} className="group transition duration-300 space-y-3 flex flex-col items-center">
                <div className="w-full h-[360px] flex items-center justify-center">
                  <img
                    src={img}
                    alt={`Wine gallery ${index + 1}`}
                    className="max-h-full w-full object-contain group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <p className="text-center text-lg font-medium text-[--primary-wine] max-w-[280px] flex justify-center">
                  {prices[index] || "Price on request"}
                </p>
                <button
                  // Route directly to the specific product if it exists, otherwise to the main products page
                  onClick={() => navigate(isWineAvailable ? `/product/${currentWineId}` : "/products")}
                  className="mt-2 inline-block bg-[--primary-wine] text-white text-sm px-4 py-2 rounded hover:bg-[--primary-wine-hover] transition"
                >
                  {isWineAvailable ? "View Details" : "View All Wines"}
                </button>
              </div>
            );
          })}
        </div>

        {/* CTA BANNER */}
        <div className="bg-[--primary-wine] text-white text-center py-14 px-6 rounded-3xl shadow-2xl">
          <h2 className="text-3xl sm:text-4xl font-bold mb-3">Taste the Legacy</h2>
          <p className="text-base sm:text-lg max-w-xl mx-auto mb-6 text-gray-100">
            Visit us or place your order online — and experience the bold, handcrafted flavors passed down through generations.
          </p>
          <button className="bg-[--accent-gold] text-[--neutral-black] px-6 py-3 font-semibold rounded-md hover:bg-[--accent-gold-hover] transition" onClick={() => navigate("/products")}>
            Explore Our Wines
          </button>
        </div>
      </div>
    </section>
  );
};

export default Gallery;